import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initSentry } from './lib/sentry';
import './index.css';
import '@fiado/react-kit/styles';
import './editorial-preview.css'; // PREVIEW rediseño Editorial — se carga último para ganar la cascada

initSentry();

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');
createRoot(root).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
